var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon eye",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.694,
    height: 14.119,
    viewBox: "0 0 20.694 14.119",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_414",
    "data-name": "Groupe 414",
    transform: "translate(-35.994 -140.888)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_507",
    "data-name": "Trac\\xE9 507",
    d: "M37.1,147.765A1.1,1.1,0,0,1,36.218,146a13.791,13.791,0,0,1,8.941-5.06c3.732-.358,7.492,1.144,11.166,4.463a1.1,1.1,0,1,1-1.475,1.633c-3.2-2.889-6.385-4.2-9.481-3.906a11.637,11.637,0,0,0-7.392,4.192,1.1,1.1,0,0,1-.877.443Z",
    fill: "#181a3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Soustraction_4",
    "data-name": "Soustraction 4",
    d: "M46.341,155.007a5.062,5.062,0,1,1,5.142-5.06A5.062,5.062,0,0,1,46.341,155.007Zm0-7.794A2.733,2.733,0,1,0,48.3,148a2.734,2.734,0,0,0-1.961-.785Z",
    fill: "#181a3a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.bba91f88e9e07e784736f39163c1bddb.svg";
export { ForwardRef as ReactComponent };